module.exports = __webpack_public_path__ + "media/images/icons/social/whatsapp-9f5e1a9a680250a2d6c736df0228c922.svg";